module.exports = __webpack_public_path__ + "media/images/card-3d1f80523f4a52c25ea08483349e7659.png";